'use strict';
const { getDependencyClass } = require('../../../lib/dependencies.js');
const { inViewEventName, outOfViewEventName } = require('../eventNames.js');

getDependencyClass('phoenix-page').then((pageClass) => {
    class PhoenixFlatGallerySlide extends pageClass.PhoenixElement {
        connectedCallback() {
            super.connectedCallback();
            this.init();
        }

        init() {
            this.observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        this.notify(entry.isIntersecting);
                    });
                },
                {
                    rootMargin: '100px',
                    threshold: 0.5,
                }
            );
            this.observer.observe(this);
        }

        notify(isIntersecting) {
            const eventName = isIntersecting ? inViewEventName : outOfViewEventName;

            this.emitEvent(eventName, {
                bubbles: true,
                detail: {
                    key: eventName,
                },
            });
        }

        disconnectedCallback() {
            this.observer.unobserve(this);
        }
    }

    window.customElements.whenDefined('phoenix-flat-gallery').then(() => {
        window.customElements.define('phoenix-flat-gallery-slide', PhoenixFlatGallerySlide);
    });
});
